import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import { connect } from "react-redux";
import { BREAKING_NEWS_UPDATED } from '../store/actions';
import { getRequest } from './api-client';

var BreakingNewsBase = /*#__PURE__*/function (_React$Component) {
  _inherits(BreakingNewsBase, _React$Component);

  var _super = /*#__PURE__*/_createSuper(BreakingNewsBase);

  function BreakingNewsBase() {
    _classCallCheck(this, BreakingNewsBase);

    return _super.apply(this, arguments);
  }

  _createClass(BreakingNewsBase, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(this.props.view, this.props);
    }
  }, {
    key: "updateBreakingNews",
    value: function updateBreakingNews() {
      var _this = this;

      getRequest('/api/v1/breaking-news').json(function (response) {
        return _this.props.breakingNewsUpdated(response.stories);
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.interval = global.setInterval(function () {
        return _this2.updateBreakingNews();
      }, this.props.updateInterval || 60000);
      this.updateBreakingNews();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      global.clearInterval(this.interval);
    }
  }]);

  return BreakingNewsBase;
}(React.Component);

function mapStateToProps(state) {
  return {
    config: state.qt.config || {},
    breakingNews: state.breakingNews || [],
    breakingNewsLoaded: state.breakingNewsLoaded || false
  };
}

function mapDispatchToProps(dispatch) {
  return {
    breakingNewsUpdated: function breakingNewsUpdated(stories) {
      return dispatch({
        type: BREAKING_NEWS_UPDATED,
        stories: stories
      });
    }
  };
}
/**
 * This component will automatically fetch breaking news every 30 seconds, and render the provided view.
 *
 * Example
 * ```javascript
 * import { renderBreakingNews } from '@quintype/framework/client/start';
 * const BreakingNewsView = ({breakingNews, breakingNewsLoaded}) =>
 *   <ul>{breakingNews.map((item, index) => <li key={index}><BreakingNewsItem item={item} /></li>)}</ul>
 * renderBreakingNews('breaking-news-container', store, BreakingNewsView);
 * ```
 * @see {@link BreakingNewsItem}
 * @component
 * @category Header
 */


export var BreakingNews = /*#__PURE__*/connect(mapStateToProps, mapDispatchToProps)(BreakingNewsBase);